import { Box, Button, HStack, Text, VStack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { useEffect, useRef } from "react";
import { EventDetailDescriptionSectionData } from "@common/interfaces/KYDEvent";
import { defaultBubbleMenuConfig, TipTapEditor } from "../../../../ui/editor";
import { Editor } from "@tiptap/react";

import markdownIt from "markdown-it";

const md = markdownIt({
  breaks: true,
});

const DescriptionStep = ({
  data,
  isLoading = false,
}: {
  data: Pick<
    EventDetailDescriptionSectionData,
    "description" | "description_rich"
  >;
  isLoading?: boolean;
}) => {
  const {
    setValue,
    watch,
    trigger,
    formState: { defaultValues },
  } = useFormContext();
  const description = watch("description");
  const description_rich = watch("description_rich");

  const editorRef = useRef<Editor>(null);

  // Set editor content when component mounts or data changes
  useEffect(() => {
    if (!editorRef.current) return;

    if (description_rich) {
      editorRef.current.commands.setContent(description_rich);
    } else if (description) {
      const rendered = md.render(description);
      editorRef.current.commands.setContent(rendered);
    }
  }, [editorRef.current]);

  return (
    <VStack w="full" py={4}>
      <HStack w="full" justifyContent={"space-between"}>
        <Text w="full" fontWeight={"medium"}>
          Event Description
        </Text>
        <Button
          hidden={description === defaultValues.description}
          variant={"link"}
          fontSize={"xs"}
          color={"gray.500"}
          flexShrink={0}
          cursor={"pointer"}
          onClick={() => {
            editorRef.current?.commands.setContent(
              defaultValues.description_rich ||
                md.render(defaultValues.description || "")
            );
            setValue("description_rich", defaultValues.description_rich);
          }}
        >
          Revert to saved
        </Button>
      </HStack>
      <Box
        minH={"400px"}
        borderWidth={1}
        borderColor={"gray.300"}
        borderRadius={"md"}
        w="full"
      >
        <TipTapEditor
          ref={editorRef}
          value={description_rich}
          bubbleMenuConfig={{
            ...defaultBubbleMenuConfig,
            showColorSelector: false,
          }}
          onChange={(value) => {
            setValue("description_rich", value, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }}
          isDisabled={isLoading}
        />
      </Box>
    </VStack>
  );
};

export default DescriptionStep;
